import React, { useState, useEffect } from 'react'
import { Box, Paper, Text, Grid, Flex, Button, NumberFormatter, Divider, Modal } from '@mantine/core'
import { useSelector, useDispatch } from 'react-redux'
import { getListCommisionUser, deleteCommisionUser } from '../../../../../services/users'
import LoadingData from '../../../../ui/LoadingData'
import { useParams } from 'react-router-dom'
import NoData from '../../../../ui/NoData'
import TableUserCommision from './TableUserCommision'
import FormAdjustAccountUser from './FormAdjustAccountUser'
import FormAdjustBalanceUser from './FormAdjustBalanceUser'
import { modalDeleteData } from '../../../../ui/Prompt/modalDeleteData'
import { getUserDetail } from '../../../../../store/userDetail'

const labelTable = [
  {
    label: 'No.',
    width: 50
  },
  {
    label: 'Date',
    width: 150
  },
  {
    label: 'Type',
    width: 200
  },
  {
    label: 'Supplier',
    width: 250
  },
  {
    label: 'Ref',
    width: 150
  },
  {
    label: 'Amount',
    width: 250
  },
  {
    label: 'Balance',
    width: 250
  },
  {
    label: 'Action',
    width: 70
  },
]

const UserCredits = () => {
  const params = useParams()
  const userId = params.id

  const dispatch = useDispatch()

  const { isLoadingUser, balanceHistory } = useSelector((state) => state.user_detail)
  const infoPayment = balanceHistory.payments
  const infoSignupCountry = balanceHistory.signupcountry

  const [loadingData, setLoadingData] = useState(true)
  const [commisionList, setCommisionList] = useState([])

  const [detailData, setDetailData] = useState(null)

  const [openModalInfoPayment, setOpenModalInfoPayment] = useState(false)
  const [openModalAdjustBalance, setOpenModalAdjustBalance] = useState(false)

  const handleGetCommision = async () => {
    setLoadingData(true)
    const params = {
      'page[num]': 1,
      'page[limit]': 25,
      'filter[user.id][is]': userId,
      sort: '-created_at',
    }
    try {
      const response = await getListCommisionUser(params)
      if (response.success) {
        const resData = response.data

        const remapData = resData.map((val) => {
          return val.attributes
        })

        setCommisionList(remapData)
      } else {
        setCommisionList([])
      }
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingData(false)
    }
  }

  useEffect(() => {
    handleGetCommision()
    // eslint-disable-next-line
  }, [userId])

  const actions = {
    edit: (val) => {
      setDetailData(val)
      setOpenModalAdjustBalance(true)
    },
    delete: (val) => {
      modalDeleteData('Balance History', val.id, val.label, deleteCommisionUser, () => [dispatch(getUserDetail(userId)), handleGetCommision()])
    }
  }

  const handleAction = (val, type) => {
    return actions[type](val)
  }

  const onCloseModalAccount = () => {
    setOpenModalInfoPayment(false)
    setDetailData(null)
  }

  const onCloseModalAdjustBalance = () => {
    setOpenModalAdjustBalance(false)
    setDetailData(null)
  }

  const loadData = () => {
    const loadCommisionData = (data) => {
      if (data.length > 0) {
        return <TableUserCommision label={labelTable} data={data} actionMethod={handleAction} />
      } else {
        return <NoData />
      }
    }
    return (
      <Box my='xl'>
        <Grid mb='xl'>
          <Grid.Col span={6}>
            <Paper p='md' withBorder shadow='xs' radius='md'>
              <Flex justify='space-between' align='center' mb='md'>
                <Text fw={500}>
                  Membership Details
                </Text>
                <Button size='compact-sm' fz='xs' onClick={() => setOpenModalInfoPayment(true)}>Edit</Button>
              </Flex>
              <Box>
                <Text fz={12.5} mb={2}>Withdraw Method : {infoPayment.withdraw_platform || '-'}</Text>
                <Text fz={12.5} mb={2}>Bank Account Name : {infoPayment.remarks || '-'}</Text>
                <Text fz={12.5} mb={2}>Bank Account Number : {infoPayment.value || '-'}</Text>
              </Box>
            </Paper>
          </Grid.Col>
          <Grid.Col span={6}>
            <Flex justify='flex-end' align='end'>
              <Box ta='right'>
                <Text fw={600} mb={4}>
                  Credit Balance :
                  <NumberFormatter prefix={` ${infoSignupCountry.currency} `} thousandSeparator="," decimalSeparator="." decimalScale={2} fixedDecimalScale={true} value={balanceHistory.balance || 0} />
                </Text>
                <Button size='xs' onClick={() => setOpenModalAdjustBalance(true)}>Add Credit Balance</Button>
              </Box>
            </Flex>
          </Grid.Col>
        </Grid>
        <Box>
          <Paper p='md' withBorder shadow='xs' radius='md'>
            <Text fw={500}>
              Balance History
            </Text>
            <Divider my='xs' />
            <Box my={20}>
              {loadingData ? <LoadingData/> : loadCommisionData(commisionList)}
            </Box>
          </Paper>
        </Box>
      </Box>
    )
  }
  return (
    <Box>
      {isLoadingUser ? <LoadingData /> : loadData()}
      <Modal
        opened={openModalInfoPayment}
        onClose={onCloseModalAccount}
        centered
        closeOnClickOutside={false}
        size='md'
        title={<Text fw='Bold'>Withdraw Setting</Text>}
        withCloseButton={false}
      >
        <FormAdjustAccountUser
          userId={userId}
          dataUserPayment={infoPayment}
          onCloseForm={onCloseModalAccount}
        />
      </Modal>
      <Modal
        opened={openModalAdjustBalance}
        onClose={onCloseModalAdjustBalance}
        centered
        closeOnClickOutside={false}
        size='md'
        title={<Text fw='Bold'>Credit Balance</Text>}
        withCloseButton={false}
      >
        <FormAdjustBalanceUser
          userId={userId}
          dataBalance={detailData}
          onCloseForm={onCloseModalAdjustBalance}
          reloadList={handleGetCommision}
        />
      </Modal>
    </Box>
  )
}

export default UserCredits